<template>
	<div class="about-page">
		<div class="header" :style="{ 'background-image': `url(${images.bg})` }">
			<div class="text">
				<h1>GET INSPIRED BY MEMORIES</h1>
				<p>
					During these times, when travel is nearly at a standstill, we dream of our past trips, the
					experiences we had, the people we met, dishes we tasted, and cultures we saw. These authentic
					experiences are often provided by small sustainable businesses, which are the backbone of the
					tourism sector in the Greater Mekong Subregion, comprising of Cambodia, China (Guangxi and Yunnan
					provinces), Lao PDR, Myanmar, Thailand, and Viet Nam.
				</p>
				<p>
					<strong
						>We want to invite past travelers to share their memories in the Mekong Region and inspire
						people to plan future trips and #traveltomorrow.</strong
					>
				</p>
				<p>
					To participate, simply post your images on your Instagram, Twitter, or YouTube channel and tag them
					with #MekongMemories. Optionally, you can also add the # of the country/destination or experience in
					the photo to support local businesses. Ask your friends to go to Mekongmemories.com and like your
					images. Each like gives you one chance in our lucky draws for travel prizes in the Mekong Region.
				</p>
			</div>
		</div>
		<div class="container">
			<div class="sponsors">
				<div class="poweredby">
					<p>POWERED BY:</p>
					<img :src="images.mtco" />
				</div>
				<div class="initiatedby">
					<p>INITIATED BY:</p>
					<img :src="images.destinationMekong" />
				</div>
			</div>

			<div class="about-text">
				<h2>About the Mekong Tourism Coordinating Office</h2>
				<p>
					The Mekong Tourism Coordinating Office (MTCO), located in Bangkok, was set up with funding from the
					governments of the six Greater Mekong Sub-region (GMS) countries – Cambodia, the People’s Republic
					of China, Laos, Myanmar, Thailand, and Viet Nam. The MTCO, which operates on annual financial
					contributions from each GMS country, acts as the secretariat for the GMS Tourism Working Group,
					comprising of senior officials of the six GMS countries’ National Tourism Organizations, to
					coordinate and facilitate sustainable tourism development of the GMS, and promotion of the Mekong
					region as a single travel and tourism destination, in collaboration with the public and private
					sectors.
				</p>
				<p>
					The MTCO manages its award-winning MekongTourism.org digital platform as a one-stop platform to
					promote responsible and sustainable tourism in the region, as well as the annual Mekong Tourism
					Forum, whose hosting is rotated among GMS countries.
				</p>
				<p>Please visit <a href="https://www.mekongtourism.org/" target="_blank" rel="noopener noreferrer">www.MekongTourism.org</a> for more information.</p>
			</div>

			<div class="about-text">
				<h2>About Destination Mekong</h2>
				<p>
					Destination Mekong was created in 2017 to promote the Mekong region, comprising of Cambodia, PR
					China (Provinces of Guangxi and Yunnan), Lao PDR, Myanmar, Thailand and Viet Nam as a single tourism
					destination to stimulate responsible and sustainable development and investment, and drive inclusive
					growth.
				</p>
				<p>
					Endorsed by the Mekong Tourism Coordinating Office and aligned with the mandate of the regional collaborative tourism framework of the six-member governments of the Greater Mekong Sub-region, Destination Mekong executes targeted projects and initiatives, including Mekong Moments, Mekong Mini Movie Festival, Mekong Innovative Startups in Tourism (MIST), Experience Mekong Collection, Mekong Heroes, and Mekong Trends, with feedback from the Mekong Tourism Advisory Group (MeTAG) and via public-private partnership investment structure, led by UNWTO Affiliate Member Chameleon Strategies. 
				</p>
				<p>Please visit <a href="https://www.destinationmekong.com/" target="_blank" rel="noopener noreferrer">www.DestinationMekong.com</a> for more information.</p>
			</div>
		</div>
	</div>
</template>

<script>
import bg from '@/assets/images/about-bg.jpg';
import mtco from '@/assets/images/mtco.png';
import destinationMekong from '@/assets/images/destination-mekong.png';

export default {
	data() {
		return {
			images: {
				bg,
				mtco,
				destinationMekong,
			},
		};
	},
};
</script>

<style lang="scss">
.about-page {
	.header {
		width: 100%;
		background-position: center;
		background-size: cover;
		padding: 30px 20px;

		.text {
			background-color: rgba(255, 255, 255, 0.8);
			padding: 30px;
			width: 80%;
			margin: 0 auto;
			font-size: 18px;
		}
	}

	.sponsors {
		margin: 30px 0 80px;
		display: flex;

		.initiatedby {
			margin-left: 50px;
		}
	}

	.about-text {
		margin-bottom: 50px;

		h2 {
			margin-bottom: 30px;
		}

		p {
			margin-bottom: 1.25em;
		}

    a {
      color: #000;
      text-decoration: none;
    }
	}

	@media screen and (min-width: 992px) {
		.header {
			padding: 80px 30px;

			.text {
				position: relative;
				left: 50%;
				margin: 0;
				width: 700px;
			}
		}
	}
}
</style>
